class FakeData
{
    getFakeData(){
        let data = [];
        let dataBPM = [];
        let dataWeight = [];
        let fromDate = new Date('2018-10-1');
        let dataMEWC = {startDate:'2018-10-25', startWeight:71.7, endDate:'2018-11-24', goalWeight:67.2, ticks:[]};

        for(var i=0;i<30;i++)
        {
            var date = new Date(this.formatDate2(fromDate));
            date.setDate(date.getDate() + i);

            const day = this.formatDate2(date);
            data.push({
                        day: day,
                        type:"main",
                        ambp: [this.getRandomNumber(40,99,0), this.getRandomNumber(100,150,0)] ,
                        pmbp:[this.getRandomNumber(40,99,0), this.getRandomNumber(100,150,0)] ,
                        ammc:this.getRandomTrueFalse(),
                        nnmc:this.getRandomTrueFalse(),
                        pmmc:this.getRandomTrueFalse(),
                        feelings:{
                            feeling:this.getRandomNumber(1,5,0),
                            conditions:this.getRandomConditioins(),
                            memo:this.getRandomTrueFalse()
                        }
                    });

            dataBPM.push(
                {
                    day: day + " 09:00:00",
                    type:"BPM",
                    period: 'am',
                    bpm:this.getRandomNumber(30,85,0),
                }
            );

            dataBPM.push(
                {
                    day: day + " 14:00:00",
                    type:"BPM",
                    period: 'pm',
                    bpm:this.getRandomNumber(30,85,0),
                }
            );

            dataWeight.push(
                {
                    day: day + " 09:00:00",
                    type:"weight",
                    period: 'am',
                    weight: this.getRandomNumber(70,75,1),
                }
            );

            dataWeight.push(
                {
                    day: day + " 14:00:00",
                    type:"weight",
                    period: 'pm',
                    weight: this.getRandomNumber(70,75,1),
                }
            );

            let dateMEWC = new Date(this.formatDate2(dataMEWC.startDate));
            dateMEWC.setDate(dateMEWC.getDate() + i);
            dateMEWC = this.formatDate2(dateMEWC);
            dataMEWC.ticks.push(
                {
                    day: dateMEWC,
                    check: this.getRandomTrueFalse()
                }
            )
        }

        let fullData = {main:null, bpm:null, weight:null, mewc:null};
        fullData.main = data;
        fullData.bpm = dataBPM;
        fullData.weight = dataWeight;
        fullData.mewc = dataMEWC;

        console.group("FakeData");
        console.log(fullData)
        console.groupEnd();
        return fullData;
    }

    getFakeData2(){
        const data = [
            { day: '2018-10-01', type:"main", ambp: [98, 132] , pmbp:[84, 139] , ammc:1, nnmc:1, pmmc:1 , feelings:{feeling:1, conditions:[1,4], memo:1}},
            { day: '2018-10-02', type:"main", ambp: [86, 130] , pmbp:[80, 131] , ammc:1, nnmc:1, pmmc:1 , feelings:{feeling:2, conditions:null, memo:1}},
            { day: '2018-10-03', type:"main", ambp: [84, 128] , pmbp:[81, 135] , ammc:1, nnmc:null, pmmc:1, feelings:{feeling:3, conditions:null, memo:1}},
            { day: '2018-10-04', type:"main", ambp: [79, 123] , pmbp:[86, 131] , ammc:1, nnmc:1, pmmc:1, feelings:{feeling:4, conditions:null, memo:1}},
            { day: '2018-10-05', type:"main", ambp: [81, 130] , pmbp:[94, 132] , ammc:1, nnmc:1, pmmc:1, feelings:{feeling:5, conditions:[1,2,3,5,6], memo:1}},
            { day: '2018-10-06', type:"main", ambp: [81, 132] , pmbp:[82, 128] , ammc:1, nnmc:1, pmmc:null, feelings:{feeling:1, conditions:[1,2,3,4,5,6], memo:1}},
            { day: '2018-10-07', type:"main", ambp: [100, 139] , pmbp:[100, 140] , ammc:1, nnmc:1, pmmc:1, feelings:{feeling:5, conditions:[1,2,3,4,5,6], memo:1}},
        ];

        const dataBPM = [
            { day: '2018-10-01 09:00:00', type:"BPM", period: 'am', bpm:51},
            { day: '2018-10-01 14:00:00', type:"BPM", period: 'pm', bpm:60},
            { day: '2018-10-02 09:00:00', type:"BPM", period: 'am', bpm:49},
            { day: '2018-10-02 14:00:00', type:"BPM", period: 'pm', bpm:62},
            { day: '2018-10-03 09:00:00', type:"BPM", period: 'am', bpm:50},
            { day: '2018-10-03 14:00:00', type:"BPM", period: 'pm', bpm:69},
            { day: '2018-10-04 09:00:00', type:"BPM", period: 'am', bpm:59},
            { day: '2018-10-04 14:00:00', type:"BPM", period: 'pm', bpm:71},
            { day: '2018-10-05 09:00:00', type:"BPM", period: 'am', bpm:null},
            { day: '2018-10-05 14:00:00', type:"BPM", period: 'pm', bpm:63},
            { day: '2018-10-06 09:00:00', type:"BPM", period: 'am', bpm:51},
            { day: '2018-10-06 14:00:00', type:"BPM", period: 'pm', bpm:62},
            { day: '2018-10-07 09:00:00', type:"BPM", period: 'am', bpm:100},
            { day: '2018-10-07 14:00:00', type:"BPM", period: 'pm', bpm:100},
        ];

        const dataWeight = [
            { day: '2018-10-01 09:00:00', type:"weight", period: 'am', weight:70.1},
            { day: '2018-10-01 14:00:00', type:"weight", period: 'pm', weight:70.5},
            { day: '2018-10-02 09:00:00', type:"weight", period: 'am', weight:70.6},
            { day: '2018-10-02 14:00:00', type:"weight", period: 'pm', weight:70.9},
            { day: '2018-10-03 09:00:00', type:"weight", period: 'am', weight:71.1},
            { day: '2018-10-03 14:00:00', type:"weight", period: 'pm', weight:71.5},
            { day: '2018-10-04 09:00:00', type:"weight", period: 'am', weight:71.2},
            { day: '2018-10-04 14:00:00', type:"weight", period: 'pm', weight:71.5},
            { day: '2018-10-05 09:00:00', type:"weight", period: 'am', weight:71.7},
            { day: '2018-10-05 14:00:00', type:"weight", period: 'pm', weight:72.0},
            { day: '2018-10-06 09:00:00', type:"weight", period: 'am', weight:null},
            { day: '2018-10-06 14:00:00', type:"weight", period: 'pm', weight:72.3},
            { day: '2018-10-07 09:00:00', type:"weight", period: 'am', weight:72.1},
            { day: '2018-10-07 14:00:00', type:"weight", period: 'pm', weight:72.8},
        ];

        let dataMEWC = {startDate:'2018-10-02', startWeight:71.7, goalWeight:68.2, endDate:'2018-10-31', ticks:[
            {day:'2018-10-02', check: true},
            {day:'2018-10-03', check: true},
            {day:'2018-10-04', check: true},
            {day:'2018-10-05', check: true},
            {day:'2018-10-06', check: true},
            {day:'2018-10-07', check: true},
            {day:'2018-10-08', check: true},
            {day:'2018-10-09', check: true},
            {day:'2018-10-10', check: true},
            {day:'2018-10-11', check: true},
            {day:'2018-10-12', check: true},
            {day:'2018-10-13', check: true},
            {day:'2018-10-14', check: true},
            {day:'2018-10-15', check: true},
            {day:'2018-10-16', check: true},
            {day:'2018-10-17', check: true},
            {day:'2018-10-18', check: true},
            {day:'2018-10-19', check: true},
            {day:'2018-10-20', check: true},
            {day:'2018-10-21', check: true},
            {day:'2018-10-22', check: true},
            {day:'2018-10-23', check: true},
            {day:'2018-10-24', check: true},
            {day:'2018-10-25', check: true},
            {day:'2018-10-26', check: true},
            {day:'2018-10-27', check: true},
            {day:'2018-10-28', check: true},
            {day:'2018-10-29', check: true},
            {day:'2018-10-30', check: true},
            {day:'2018-10-31', check: true},
        ]};

        let dataStep ={};
        let dataSleep ={};

        let fullData = {main:null, bpm:null, weight:null, mewc:null ,step:null ,sleep:null};
        fullData.main = data;
        fullData.bpm = dataBPM;
        fullData.weight = dataWeight;
        fullData.mewc = dataMEWC;
        fullData.step = dataStep;
        fullData.sleep = dataSleep;

        console.group("FakeData");
        console.log(fullData)
        console.groupEnd();
        return fullData;
    }

    getFakeTemperatureData(){
        const dataTemperature = [
            { day: '2020-08-04 09:00:00', type:"temperature", period: 'am', temperature:36},
            { day: '2020-08-04 14:00:00', type:"temperature", period: 'pm', temperature:36.5},
            { day: '2020-08-05 09:00:00', type:"temperature", period: 'am', temperature:37.6},
            { day: '2020-08-05 14:00:00', type:"temperature", period: 'pm', temperature:36.9},
            { day: '2020-08-06 09:00:00', type:"temperature", period: 'am', temperature:37.1},
            { day: '2020-08-06 14:00:00', type:"temperature", period: 'pm', temperature:36.5},
            { day: '2020-08-07 09:00:00', type:"temperature", period: 'am', temperature:34.2},
            { day: '2020-08-07 14:00:00', type:"temperature", period: 'pm', temperature:38.5},
            { day: '2020-08-08 09:00:00', type:"temperature", period: 'am', temperature:38.7},
            { day: '2020-08-08 14:00:00', type:"temperature", period: 'pm', temperature:35.0},
            { day: '2020-08-09 09:00:00', type:"temperature", period: 'am', temperature:null},
            { day: '2020-08-09 14:00:00', type:"temperature", period: 'pm', temperature:35.3},
            { day: '2020-08-10 09:00:00', type:"temperature", period: 'am', temperature:36.1},
            { day: '2020-08-10 14:00:00', type:"temperature", period: 'pm', temperature:35.8},
        ];
        let fullData = {list:null};
        fullData.list = dataTemperature;
        return fullData;
    }
    getFakeBGData(){

    }
    getFakeSPO2Data(){

    }

    getRandomNumber(low, high, decimals)
    {
        var result = Math.random() * (high - low) + low;
        if(decimals == 0)
        {
            return parseInt(result);
        }

        return parseFloat(result.toFixed(decimals));
    }

    getRandomTrueFalse()
    {
        const result = this.getRandomNumber(0,2,0);
        if(result == 0)
        {
            return null;
        }

        return result;
    }

    getRandomConditioins()
    {
        const result = this.getRandomNumber(0,2,0);
        switch(result)
        {
            case 0:
                return null;
                break;
            case 1:
                return [1,3,4];
                break;
            case 2:
                return [2,3,4,5];
                break;
            case 3:
                return [1,2,3,4,5,6];
                break;
        }
    }

    formatDate2(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }
}

module.exports = new FakeData();



// WEBPACK FOOTER //
// ./src/components/graph/data/FakeData.jsx